import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Select } from '@ngxs/store';
import { Observable, map } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import { Terminal } from '@app/shared/classes/terminal';
import { DataGridComponent } from '@app/shared/components/smart-data-grid/data-grid/data-grid.component';
import { NgxsActionName } from '@app/shared/constants';
import { AppDataState } from '@app/shared/stores/app-data.state';
import { TerminalListDataGridColumnDef } from '@app/pages/team-message/team-message.constant';

@Component({
  selector: 'app-receiver-terminal-list',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, MatDialogModule, DataGridComponent],
  templateUrl: './receiver-terminal-list.component.html',
  styleUrl: './receiver-terminal-list.component.css'
})
export class ReceiverTerminalListComponent implements OnInit {
  terminalListDataGridColumnDef = TerminalListDataGridColumnDef;
  dataSource$: Observable<Terminal[]>;

  @Select(AppDataState.taskResponse(NgxsActionName.GET_DRIVER_RELATED_TERMINAL_LIST)) terminals$: Observable<Terminal[]>;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public terminal_Ids: number[]) {
  }

  ngOnInit() {
    this.dataSource$ = this.terminals$.pipe(map(items => {
      return items.filter(item => {
        return this.terminal_Ids.find(terminal_id => terminal_id === item.terminal_Id) !== undefined;
      });
    }));
  }
}
